"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAssignationsToAcceptanceRateInfo = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const AcceptanceRateInfo_1 = require("../models/AcceptanceRateInfo");
function transformAssignationsToAcceptanceRateInfo(assignations) {
    const assignationsStats = { acceptedCount: 0, declinedCount: 0 };
    assignations.reduce((accumulator, a) => {
        if (a.status === legacy_enums_1.AssignationStatus.Accepted) {
            accumulator.acceptedCount += 1;
        }
        else if (a.status === legacy_enums_1.AssignationStatus.Declined) {
            accumulator.declinedCount += 1;
        }
        return accumulator;
    }, assignationsStats);
    // If driver is new and accepted/declined nothing - we cannot say that he is "zombie". Can we?
    const rate = assignationsStats.declinedCount || assignationsStats.acceptedCount
        ? assignationsStats.acceptedCount / (assignationsStats.acceptedCount + assignationsStats.declinedCount)
        : null;
    const acceptanceRateInfo = new AcceptanceRateInfo_1.AcceptanceRateInfo();
    acceptanceRateInfo.assignationsAccepted = assignationsStats.acceptedCount;
    acceptanceRateInfo.assignationsDeclined = assignationsStats.declinedCount;
    acceptanceRateInfo.rate = rate;
    return acceptanceRateInfo;
}
exports.transformAssignationsToAcceptanceRateInfo = transformAssignationsToAcceptanceRateInfo;
//# sourceMappingURL=transformAssignationsToAcceptanceRateInfo.js.map